const USER_AGREEMENT_ACTIONS = {
  skip: 'SKIP',
  clear: 'CLEAR',
};

export default USER_AGREEMENT_ACTIONS;
